// @flow
/* eslint-disable react/no-multi-comp */

import React, { type Node } from 'react';
import cx from 'classnames';

type GenericReactComp = {
    children: Node,
    className?: string
};

type GridPropTypes = GenericReactComp & {
    caption?: string
};

const Grid = React.memo<GridPropTypes>(({
    children,
    className,
    caption,
    ...otherProps
}: GridPropTypes) => {
    return (
        <div
            data-component="Grid"
            role="grid"
            aria-label={caption}
            className={cx('rec-grid-grid', className)}
            {...otherProps} >
            {children}
        </div>
    );
})

type RowProps = GenericReactComp & {innerRef?: any};
const Row = React.memo<RowProps>(({
    children,
    className,
    innerRef,
    ...otherProps
}: RowProps) => {
    return (
        <div
            {...otherProps}
            data-component="Row"
            role="row"
            className={cx('rec-grid-row', className)}
            ref={innerRef} >
            {children}
        </div>
    );
})

const GridHeaderCell = React.memo<GenericReactComp>(({
    children,
    className,
    ...otherProps
}: GenericReactComp) => {
    return (
        <div
            {...otherProps}
            data-component="GridHeaderCell"
            role="columnheader"
            className={cx('rec-grid-row', className)}>
            {children}
        </div>
    );
})

const GridCell = React.memo<GenericReactComp>(({
    children,
    className,
    ...otherProps
}: GenericReactComp) => {
    return (
        <div
            {...otherProps}
            data-component="GridCell"
            role="gridcell"
            className={cx('rec-grid-grid-cell', className)}>
            {children}
        </div>
    );
})

export { Grid, Row, GridHeaderCell, GridCell };